// DashboardLayout.js
import { Outlet } from "react-router-dom";
import Topheader from "../components/dashboard/header";
import Leftsidebar from "../components/dashboard/leftsidebar";
import { useSelector } from "react-redux";
import Bottombar from "../components/bottombar";

const DashboardLayout = () => {
  // const dispatch = useDispatch();
  // const navigate = useNavigate();

  // const handleLogout = () => {
  //   dispatch(logout());
  //   navigate("/login");
  // };
  const state = useSelector((s) => s.signup.token);

  return (
    <>
      {/* <header style={{ padding: '20px', background: '#333', color: '#fff' }}>
        <nav>
          <ul style={{ listStyle: 'none', display: 'flex', gap: '20px' }}>
            <li><Link to="/dashboard" style={{ color: '#fff' }}>Dashboard</Link></li>
            <li><Link to="/profile" style={{ color: '#fff' }}>Profile</Link></li>
            <li><Link to="/settings" style={{ color: '#fff' }}>Settings</Link></li>
            <li><button onClick={handleLogout} style={{ color: '#fff', background: "#000" }}>Logout</button></li>
          </ul>
        </nav>
      </header>
      <main style={{ padding: '20px' }}>
        <Outlet /> 
      </main>
      <footer style={{ padding: '10px', background: '#333', color: '#fff' }}>
        <p>&copy; 2025 My Dashboard Application. All Rights Reserved.</p>
      </footer> */}

      <div className="bg-gradient-to-b  min-h-screen bg-[#280203] text-white">
        <Topheader />

        <main className="flex lg:flex-nowrap p-4 gap-4">
          <Leftsidebar />

          <Outlet />
        </main>
        <Bottombar />
      </div>
    </>
  );
};

export default DashboardLayout;
